import { createFileRoute } from '@tanstack/react-router';
import { Forbidden } from '@/components/shared/page-states';
import { useCan } from '@/features/auth/session';
import { ExchangeFlow } from '@/features/exchange/exchange-flow';

/** نظام صرف عملات (VIP): VIP prices, only with EXCHANGE_VIP (currency.md section 3.1). */
function VipExchange(): React.JSX.Element {
  const canVip = useCan('EXCHANGE_VIP');
  return canVip ? <ExchangeFlow vip /> : <Forbidden />;
}

export const Route = createFileRoute('/_app/vip')({
  component: VipExchange,
});
